import { __awaiter, __generator } from "tslib";
import { fetchSharedContext } from '@office-start/context-service';
import { fetchMruConfig } from '@office-start/mru-config-service';
export function executeRecommendedConfigDataFlow() {
    return __awaiter(this, void 0, void 0, function () {
        var mruConfig, sharedContext;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetchMruConfig()];
                case 1:
                    mruConfig = _a.sent();
                    return [4 /*yield*/, fetchSharedContext()];
                case 2:
                    sharedContext = _a.sent();
                    if (!mruConfig || !sharedContext) {
                        throw new Error('Cannot parse RecommendedConfig');
                    }
                    return [2 /*return*/, {
                            dismissedDocumentsPath: mruConfig.recommendedApiDismissedDocumentsPath,
                            // $TODO: convert mruConfig/sharedContext to feature settings for non-constant, environment dependent settings
                            filesActionsPath: "".concat(mruConfig.recommendedB2ApiFilesPath, "/actions"),
                            filesPath: mruConfig.recommendedB2ApiFilesPath,
                            numItemsToRequest: mruConfig.numRecommendedToRequest,
                            numItemsToShow: mruConfig.numRecommendedToRequest,
                            officeFeedControlEnabled: mruConfig.officeFeedControlEnabled,
                            officeFeedFlightEnabled: mruConfig.officeFeedFlightEnabled,
                            officeFeedApiRootPath: mruConfig.officeFeedApiRootPath,
                            pdfEnabled: mruConfig.recommendedPdfEnabled,
                            rootPath: mruConfig.recommendedB2ApiRootPath,
                            substrateAppId: sharedContext.recommendedIceApplicationId,
                            substrateApi: mruConfig.substrateApiEndpoint,
                            visioEnabled: mruConfig.recommendedVisioEnabled,
                            upcomingMeetingEnabled: mruConfig.upcomingMeetingEnabled,
                        }];
            }
        });
    });
}
//# sourceMappingURL=executeRecommendedConfigDataFlow.js.map